import { useEffect, useState } from "react";

function current() {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

export default function useBreakpoint() {
  const [bp, setBp] = useState(current);
  useEffect(() => {
    let frame = 0;
    function onResize() {
      // Throttle to next frame to avoid thrashing layout during drag
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setBp(current()));
    }
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);
  return bp;
}

export function isMobile(bp) { return bp === "mobile"; }
export function isTablet(bp) { return bp === "tablet"; }
export function isDesktop(bp) { return bp === "desktop"; }
